import { pState } from '../../store';

/** 大陆 / 香港 / 澳门的国籍固定预设；其它国家/地区由用户在证件页选择 */
export const COUNTRY_BY_ID_CARD: Record<string, string> = {
  MAINLAND_CHINA: 'CN',
  HONG_KONG: 'HK',
  MACAO: 'MO',
};

/** 前三种身份写入固定国籍；从这三种改到「其它」时清掉预设，避免把 CN/HK/MO 当成已选国籍 */
export const applyNationalityForIdentity = (nextType: string, prevType?: string) => {
  const preset = COUNTRY_BY_ID_CARD[nextType];
  if (preset) {
    pState.uploadLicForm.nationality = preset;
    return;
  }
  if (nextType === 'OTHER_REGION' && prevType && COUNTRY_BY_ID_CARD[prevType]) {
    pState.uploadLicForm.nationality = '';
  }
};

/** 大陆身份以 identityType 为准（BACK 后 idCardType 可能已是境外证件） */
export const getTaxResidenceType = () =>
  pState.uploadLicForm.identityType || pState.uploadLicForm.idCardType;

/** 税务国家/地区代码：与证件类型（或其它国家时的国籍）一致 */
export const getTaxCountryCode = () => {
  const residenceType = getTaxResidenceType();
  if (residenceType === 'OTHER_REGION') {
    return pState.uploadLicForm.nationality || '';
  }
  return COUNTRY_BY_ID_CARD[residenceType] ?? '';
};

/** 按当前证件信息覆盖税务国家、税务编号（编号=证件号） */
export const syncTaxFieldsFromLic = () => {
  pState.taxInfoForm.isUsPerson = 0;
  pState.taxInfoForm.taxNumber = pState.uploadLicForm.idCardNo;
  pState.taxInfoForm.country = getTaxCountryCode();
};
